import { Pipe, PipeTransform } from '@angular/core';
import { FormattersHelper } from '../helpers/formatters/formatters.helper';

@Pipe({
  name: 'formatMarkdown',
  pure: true
})
export class FormatMarkdownPipe implements PipeTransform {
  transform(text: any, isInsights: boolean = false): string {
    if (Array.isArray(text)) {
      text = text[0] || '';
    }
    if (typeof text !== 'string') {
      return '';
    }
    return FormattersHelper.formatMarkdown(text, isInsights);
  }
}
